import { modifiers } from '#components/generics/js/styles.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { availability } from './add.js'

const { parseInt } = Number
const options = {
  attributes: true,
  attributeFilter: array(['value'])
}

export default input => {
  const records = mutations(input, options, removed(input))
  const form = closest('form', input)

  queueMicrotask(async () => {
    for await (const record of records) {
      for (const rsrc of all('[type="hidden"][name="new_rsrc[]"]', form)) {
        const { value } = rsrc
        const startDay = one(`.${modifiers.new_field_input.new_hidden}[name="new_start__day"]`, form)
        const startTime = one(`.${modifiers.new_field_input.new_hidden}[name="new_start__sec"]`, form)
        const endDay = one(`.${modifiers.new_field_input.new_hidden}[name="new_end__day"]`, form)
        const endTime = one(`.${modifiers.new_field_input.new_hidden}[name="new_end__sec"]`, form)
        const { value: allDay } = one(`.${modifiers.new_field_input.new_hidden}[name="new_allday"]`, form)
        let duration

        if (allDay && parseInt(allDay, 10) === 1) {
          duration = 86400
        } else {
          duration = (parseInt(endDay.value, 10) + parseInt(endTime.value, 10)) - (parseInt(startDay.value, 10) + parseInt(startTime.value, 10))

          if (duration > 86400) {
            duration = 86400
          }
        }

        await availability(input, value, startDay, startTime, duration, 'event', input)
      }
    }
  })
}
